const SELECTORS = {
    tabs: '.js-tabs'
}

const CLASSES = {
    activeTabLink: 'active'
}

class Tabs {
    constructor(el) {
        this.el = el

        this.activeTabPanel = null
        this.tabLinks = Array.from(el.querySelectorAll("a[role='tab']"))
        this.tabPanels = Array.from(el.querySelectorAll("[role='tabpanel']"))

        this.init()
    }

    init() {
        this.tabLinks.forEach((tab) => {
            tab.addEventListener('click', this.switchTab)
        })

        this.tabPanels.forEach((tabPanel) => {
            tabPanel.setAttribute('tabindex', '-1')
        })
    }

    switchTab = (e) => {
        e.preventDefault()
        const selectedTab = e.target
        this.setActiveTab(selectedTab)
    }

    setActiveTab(tab) {
        const selectedPanelRef = tab.getAttribute('href')
        const selectedPanel = this.el.querySelector(selectedPanelRef)

        if (!selectedPanel) {
            return false
        }

        const selectedTabId = selectedPanel.getAttribute('id').replace('section-', '')

        this.tabLinks.forEach((tabLink) => tabLink.classList.remove(CLASSES.activeTabLink))
        tab.classList.add(CLASSES.activeTabLink)

        this.tabPanels.forEach((tabPanel) => {
            tabPanel.hidden = true
            tabPanel.setAttribute('tabindex', '-1')
            tabPanel.removeAttribute('aria-selected')
        })

        selectedPanel.removeAttribute('hidden')
        selectedPanel.removeAttribute('tabindex')
        selectedPanel.setAttribute('aria-selected', 'true')

        this.el.dataset.activeTab = selectedTabId
        this.activeTabPanel = selectedPanel
    }
}

const tabs = document.querySelectorAll(SELECTORS.tabs)
Array.from(tabs).map((el) => new Tabs(el))
